<template>
  <div>
    <v-card color="grey lighten-5 ma-0 pa-0" :loading="loading">
      <DocumentActionHeader
        :title="$t('DistributionInternalExternal')"
        @on-close-click="onCloseClick"
      />
      <v-card-text class="overflow-y-auto" style="max-height: 250px">
        <template v-for="distribution in distributionList">
          <DistributionItem
            :distribution="distribution"
            v-bind:key="distribution.uuid"
            @on-delete-delegation="deleteDistribution"
          />
        </template>
        <v-btn @click="endAllDistributions" color="primary" block>{{ $t("Site.Distributions.FinishAllDistributions") }}</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DocumentActionHeader from '@/components/search/results/list/item/actions/DocumentActionHeader';
import DistributionItem from '@/components/search/results/list/item/actions/distribution/DistributionItem';
import DistributionService from '@/services/DistributionsService.js';
import DocumentService from '@/services/DocumentService.js';
import Distribution from '@/ecm/models/search/results/list/DistributionItem';
import Utils from '@/ecm/common/Utils';

export default {
    name: 'DistributionList',
    components: {
        DocumentActionHeader,
        DistributionItem,
    },
    props: {
        documentId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.loadData();
    },
    data() {
        return {
            distributionList: [],
            loading: false,
        };
    },
    methods: {
        onCloseClick() {
            this.$emit('on-close-click');
        },
        deleteDistribution(distribution) {
            const finishDistribution = {
                DistributionId: distribution.distributionId,
                DistributionDetailsId: distribution.distributionDetailsId
            };

            this.callEndDistribution([finishDistribution]);
        },
        endAllDistributions() {
            const distributionsToFinish = [];

            this.distributionList.forEach(element => {
                const finishDistribution = {
                    DistributionId: element.distributionId,
                    DistributionDetailsId: element.distributionDetailsId
                };

                distributionsToFinish.push(finishDistribution);
            });
            this.callEndDistribution(distributionsToFinish);
        },

        callEndDistribution(distributionsToFinish) {
            const endDistributions = {
                endDistributions: distributionsToFinish
            };

            this.loading = true;
            DistributionService.endDistribution(endDistributions)
                .then((data) => {
                    this.$emit('on-distribution-ended');
                    this.loadData();
                    Utils.toast.success(this.$t('Site.Distributions.DistributionEndedSuccessfully'));
                    this.loading = false;
                })
                .catch(() => {
                    this.loadData();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loadData() {
            this.loading = true;
            DocumentService.getDistributionList(this.documentId).then((data) => {
                this.distributionList = data.map(function (dto) {
                    return new Distribution(dto);
                });
                this.loading = false;
            });
        },
    },
};
</script>